import { render, staticRenderFns } from "./photo-material-all.vue?vue&type=template&id=b3833cb2&scoped=true&"
import script from "./photo-material-all.vue?vue&type=script&lang=js&"
export * from "./photo-material-all.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-all.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-all.vue?vue&type=style&index=1&id=b3833cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3833cb2",
  null
  
)

export default component.exports